import { useToast } from '../lib/toast';

const styles: Record<string, string> = {
  info: 'bg-indigo-600 border-indigo-400',
  success: 'bg-teal-600 border-teal-400',
  error: 'bg-rose-600 border-rose-400',
};

export function Toaster() {
  const { toasts, removeToast } = useToast();
  return (
    <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`flex items-start gap-3 p-3 rounded-lg shadow-2xl border-l-4 text-white ${styles[t.type]}`}
        >
          <span className="flex-1 text-sm font-medium">{t.message}</span>
          <button
            onClick={() => removeToast(t.id)}
            className="text-white/80 hover:text-white text-xl leading-none"
            aria-label="dismiss"
          >×</button>
        </div>
      ))}
    </div>
  );
}
